import {
  SnippetElement,
  defineElement
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-CFQW6ARL.js";

// src/snippets/pb-common-add-to-cart/pb-common-add-to-cart.ts
var PbCommonAddToCart = class extends SnippetElement {
  connectedCallback() {
    if (this.dataset.isSticky == "true") {
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && entry.intersectionRatio >= 1) {
          this.classList.add("fixed");
          this.classList.add("p-5");
          this.classList.add("m-0");
          this.classList.add("border-t");
          this.classList.add("border-phGray");
          this.classList.add("shadow-[0_-5px_5px_rgba(0,0,0,0.1)]");
          this.removeAttribute("style");
          observer.disconnect();
        }
      }, { threshold: 1 });
      observer.observe(this);
    }
  }
};
PbCommonAddToCart = __decorateClass([
  defineElement("pb-common-add-to-cart")
], PbCommonAddToCart);
export {
  PbCommonAddToCart
};
